/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppSplatRouteImport } from './routes/_app.$'
import { Route as AppAbsenceRouteImport } from './routes/_app.absence'
import { Route as AppAlertsRouteImport } from './routes/_app.alerts'
import { Route as AppClientsRouteImport } from './routes/_app.clients'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppTasksRouteImport } from './routes/_app.tasks'
import { Route as AppTeamRouteImport } from './routes/_app.team'
import { Route as AuthIndexRouteImport } from './routes/auth.index'
import { Route as Auth2faEnableRouteImport } from './routes/auth.2fa-enable'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as AuthLogoutRouteImport } from './routes/auth.logout'
import { Route as AuthPasswordResetRouteImport } from './routes/auth.password-reset'
import { Route as AppDashboardIndexRouteImport } from './routes/_app.dashboard.index'
import { Route as AppDashboardChartIdRouteImport } from './routes/_app.dashboard.$chartId'
import { Route as AppFleetIndexRouteImport } from './routes/_app.fleet.index'
import { Route as AppFleetVehicleIdRouteImport } from './routes/_app.fleet.$vehicleId'
import { Route as AppFleetAddRouteImport } from './routes/_app.fleet.add'
import { Route as AppUsersIndexRouteImport } from './routes/_app.users.index'
import { Route as AppUsersAddRouteImport } from './routes/_app.users.add'
import { Route as AppUsersUserIdCompareRouteImport } from './routes/_app.users.$userId.compare'
import { Route as AppUsersUserIdEditRouteImport } from './routes/_app.users.$userId.edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.index.lazy').then((d) => d.Route))
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppAbsenceRoute = AppAbsenceRouteImport.update({
  id: '/absence',
  path: '/absence',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsRoute = AppClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const Auth2faEnableRoute = Auth2faEnableRouteImport.update({
  id: '/2fa-enable',
  path: '/2fa-enable',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPasswordResetRoute = AuthPasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => AuthRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardChartIdRoute = AppDashboardChartIdRouteImport.update({
  id: '/dashboard/$chartId',
  path: '/dashboard/$chartId',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.dashboard.$chartId.lazy').then((d) => d.Route),
)
const AppFleetIndexRoute = AppFleetIndexRouteImport.update({
  id: '/fleet/',
  path: '/fleet/',
  getParentRoute: () => AppRoute,
} as any)
const AppFleetVehicleIdRoute = AppFleetVehicleIdRouteImport.update({
  id: '/fleet/$vehicleId',
  path: '/fleet/$vehicleId',
  getParentRoute: () => AppRoute,
} as any)
const AppFleetAddRoute = AppFleetAddRouteImport.update({
  id: '/fleet/add',
  path: '/fleet/add',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.users.index.lazy').then((d) => d.Route),
)
const AppUsersAddRoute = AppUsersAddRouteImport.update({
  id: '/users/add',
  path: '/users/add',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.users.add.lazy').then((d) => d.Route),
)
const AppUsersUserIdCompareRoute = AppUsersUserIdCompareRouteImport.update({
  id: '/users/$userId/compare',
  path: '/users/$userId/compare',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.users.$userId.compare.lazy').then((d) => d.Route),
)
const AppUsersUserIdEditRoute = AppUsersUserIdEditRouteImport.update({
  id: '/users/$userId/edit',
  path: '/users/$userId/edit',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.users.$userId.edit.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/$': typeof AppSplatRoute
  '/absence': typeof AppAbsenceRoute
  '/alerts': typeof AppAlertsRoute
  '/clients': typeof AppClientsRoute
  '/profile': typeof AppProfileRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/team': typeof AppTeamRoute
  '/auth/2fa-enable': typeof Auth2faEnableRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/': typeof AuthIndexRoute
  '/dashboard/$chartId': typeof AppDashboardChartIdRoute
  '/fleet/$vehicleId': typeof AppFleetVehicleIdRoute
  '/fleet/add': typeof AppFleetAddRoute
  '/users/add': typeof AppUsersAddRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/fleet/': typeof AppFleetIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/users/$userId/compare': typeof AppUsersUserIdCompareRoute
  '/users/$userId/edit': typeof AppUsersUserIdEditRoute
}
export interface FileRoutesByTo {
  '/$': typeof AppSplatRoute
  '/absence': typeof AppAbsenceRoute
  '/alerts': typeof AppAlertsRoute
  '/clients': typeof AppClientsRoute
  '/profile': typeof AppProfileRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/team': typeof AppTeamRoute
  '/auth/2fa-enable': typeof Auth2faEnableRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/': typeof AppIndexRoute
  '/auth': typeof AuthIndexRoute
  '/dashboard/$chartId': typeof AppDashboardChartIdRoute
  '/fleet/$vehicleId': typeof AppFleetVehicleIdRoute
  '/fleet/add': typeof AppFleetAddRoute
  '/users/add': typeof AppUsersAddRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/fleet': typeof AppFleetIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/users/$userId/compare': typeof AppUsersUserIdCompareRoute
  '/users/$userId/edit': typeof AppUsersUserIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/_app/$': typeof AppSplatRoute
  '/_app/absence': typeof AppAbsenceRoute
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/clients': typeof AppClientsRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/team': typeof AppTeamRoute
  '/auth/2fa-enable': typeof Auth2faEnableRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/_app/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/_app/dashboard/$chartId': typeof AppDashboardChartIdRoute
  '/_app/fleet/$vehicleId': typeof AppFleetVehicleIdRoute
  '/_app/fleet/add': typeof AppFleetAddRoute
  '/_app/users/add': typeof AppUsersAddRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/fleet/': typeof AppFleetIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/users/$userId/compare': typeof AppUsersUserIdCompareRoute
  '/_app/users/$userId/edit': typeof AppUsersUserIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/$'
    | '/absence'
    | '/alerts'
    | '/clients'
    | '/profile'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/auth/'
    | '/dashboard/$chartId'
    | '/fleet/$vehicleId'
    | '/fleet/add'
    | '/users/add'
    | '/dashboard/'
    | '/fleet/'
    | '/users/'
    | '/users/$userId/compare'
    | '/users/$userId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/absence'
    | '/alerts'
    | '/clients'
    | '/profile'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/'
    | '/auth'
    | '/dashboard/$chartId'
    | '/fleet/$vehicleId'
    | '/fleet/add'
    | '/users/add'
    | '/dashboard'
    | '/fleet'
    | '/users'
    | '/users/$userId/compare'
    | '/users/$userId/edit'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/_app/$'
    | '/_app/absence'
    | '/_app/alerts'
    | '/_app/clients'
    | '/_app/profile'
    | '/_app/settings'
    | '/_app/tasks'
    | '/_app/team'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/_app/'
    | '/auth/'
    | '/_app/dashboard/$chartId'
    | '/_app/fleet/$vehicleId'
    | '/_app/fleet/add'
    | '/_app/users/add'
    | '/_app/dashboard/'
    | '/_app/fleet/'
    | '/_app/users/'
    | '/_app/users/$userId/compare'
    | '/_app/users/$userId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/absence': {
      id: '/_app/absence'
      path: '/absence'
      fullPath: '/absence'
      preLoaderRoute: typeof AppAbsenceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/2fa-enable': {
      id: '/auth/2fa-enable'
      path: '/2fa-enable'
      fullPath: '/auth/2fa-enable'
      preLoaderRoute: typeof Auth2faEnableRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/password-reset': {
      id: '/auth/password-reset'
      path: '/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/$chartId': {
      id: '/_app/dashboard/$chartId'
      path: '/dashboard/$chartId'
      fullPath: '/dashboard/$chartId'
      preLoaderRoute: typeof AppDashboardChartIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fleet/': {
      id: '/_app/fleet/'
      path: '/fleet'
      fullPath: '/fleet/'
      preLoaderRoute: typeof AppFleetIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fleet/$vehicleId': {
      id: '/_app/fleet/$vehicleId'
      path: '/fleet/$vehicleId'
      fullPath: '/fleet/$vehicleId'
      preLoaderRoute: typeof AppFleetVehicleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fleet/add': {
      id: '/_app/fleet/add'
      path: '/fleet/add'
      fullPath: '/fleet/add'
      preLoaderRoute: typeof AppFleetAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/add': {
      id: '/_app/users/add'
      path: '/users/add'
      fullPath: '/users/add'
      preLoaderRoute: typeof AppUsersAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$userId/compare': {
      id: '/_app/users/$userId/compare'
      path: '/users/$userId/compare'
      fullPath: '/users/$userId/compare'
      preLoaderRoute: typeof AppUsersUserIdCompareRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$userId/edit': {
      id: '/_app/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof AppUsersUserIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppAbsenceRoute: typeof AppAbsenceRoute
  AppAlertsRoute: typeof AppAlertsRoute
  AppClientsRoute: typeof AppClientsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTasksRoute: typeof AppTasksRoute
  AppTeamRoute: typeof AppTeamRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDashboardChartIdRoute: typeof AppDashboardChartIdRoute
  AppFleetVehicleIdRoute: typeof AppFleetVehicleIdRoute
  AppFleetAddRoute: typeof AppFleetAddRoute
  AppUsersAddRoute: typeof AppUsersAddRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppFleetIndexRoute: typeof AppFleetIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppUsersUserIdCompareRoute: typeof AppUsersUserIdCompareRoute
  AppUsersUserIdEditRoute: typeof AppUsersUserIdEditRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppAbsenceRoute: AppAbsenceRoute,
  AppAlertsRoute: AppAlertsRoute,
  AppClientsRoute: AppClientsRoute,
  AppProfileRoute: AppProfileRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTasksRoute: AppTasksRoute,
  AppTeamRoute: AppTeamRoute,
  AppIndexRoute: AppIndexRoute,
  AppDashboardChartIdRoute: AppDashboardChartIdRoute,
  AppFleetVehicleIdRoute: AppFleetVehicleIdRoute,
  AppFleetAddRoute: AppFleetAddRoute,
  AppUsersAddRoute: AppUsersAddRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppFleetIndexRoute: AppFleetIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppUsersUserIdCompareRoute: AppUsersUserIdCompareRoute,
  AppUsersUserIdEditRoute: AppUsersUserIdEditRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  Auth2faEnableRoute: typeof Auth2faEnableRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthPasswordResetRoute: typeof AuthPasswordResetRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  Auth2faEnableRoute: Auth2faEnableRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthPasswordResetRoute: AuthPasswordResetRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
